<kt-splash-screen *ngIf="loader"></kt-splash-screen>
<router-outlet></router-outlet>
<kt-company-scripts></kt-company-scripts>

